import axios from "axios";
import authHeader from "./auth-header";
import { toast } from "react-toastify";

export const fetchAllFinancialyears = (filters = {}) => {
  const query_string = new URLSearchParams(filters).toString();
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/financial-year?${query_string}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const changeFinancialyear = (id) => {
  return axios
    .post(`${process.env.REACT_APP_BASE_URL}/financial-year/${id}`, {}, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};


